import { useCrefisaContext } from "@/app/contexts/CrefisaContext";
import { Button } from "@/view/components/ui/button";
import { DialogContent } from "@/view/components/ui/dialog";
import { TickCircle } from "iconsax-react";

interface ProposalSubmittedModalProps {
  onClose?: () => void;
}

export default function ProposalSubmittedModal({
  onClose,
}: ProposalSubmittedModalProps) {
  const { customerData, proposalData } = useCrefisaContext();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <DialogContent className="flex max-h-[90vh] flex-col overflow-y-auto sm:max-w-2xl">
      <div className="flex flex-col gap-8 p-6">
        <div className="flex flex-col items-start gap-2 text-left">
          <div className="flex items-center gap-2">
            <TickCircle size="40" className="text-success" />
            <h2 className="text-2xl font-semibold text-gray-900">
              Proposta realizada!
            </h2>
          </div>
          <p className="max-w-md text-sm text-gray-500">
            Sua proposta foi registrada com sucesso. Você pode acompanhar o
            status através do seu dashboard.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <span className="text-base text-gray-500">Contrato</span>
          <span className="text-3xl font-semibold text-gray-900">
            {proposalData?.contract}
          </span>
          <div className="flex gap-1 text-base">
            <span className="text-gray-500">Para</span>
            <span className="font-medium text-gray-900">
              {customerData?.name}
            </span>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <Button
            onClick={handleClose}
            className="w-full rounded-full font-semibold text-white"
          >
            Voltar para o início
          </Button>
        </div>
      </div>
    </DialogContent>
  );
}
